export default __webpack_public_path__ + "static/media/430.d5f43c62.png";